module.exports = __webpack_public_path__ + "static/media/wtw-logo.c9630ea1.svg";